export default __webpack_public_path__ + "static/media/rightArrow.d8fd86a5.png";